/* eslint-disable */
export const categories = {
  عقارات: {
    id: 0,
    name: "عقارات",
    en: "All",
    plural: "عقارات",
    uri: "عقارات",
    path: "/عقارات",
    keywords: ["عقارات", "عقار", "للبيع", "للإيجار", "تأجير", "أجار"],
    description:
      "أفضل إعلانات الفلل للبيع في جميع مدن ومناطق السعودية بالصور، تواصل مع المالك مباشرة أو المكتب و اعرف تفاصيل الحي مع خدمة تقييم الأحياء على تطبيق عقار ، تطبيق عقار",
  },
  "شقق-للإيجار": {
    id: 1,
    name: "شقة للإيجار",
    en: "Apartment for rent",
    ga_listing_type: "rent",
    ga_property_category: "apartment",
    is_rent: true,
    plural: "شقق للإيجار",
    uri: "شقق-للإيجار",
    path: "/شقق-للإيجار",
    keywords: ["شقة", "شقق", "للإيجار", "تأجير", "أجار"],
    description:
      "تصفح آلاف عقارات الشقق للايجار في جميع مدن ومناطق السعودية بأسعار ومساحات مناسبة بالصور والتفاصيل. مع الاطلاع على ميزة تقييم الحي في تطبيق عقار ، تطبيق عقار",
  },
  "أراضي-للبيع": {
    id: 2,
    name: "أرض للبيع",
    en: "Land for sale",
    ga_listing_type: "sale",
    ga_property_category: "land",
    is_rent: false,
    plural: "أراضي للبيع",
    uri: "أراضي-للبيع",
    path: "/أراضي-للبيع",
    keywords: ["أرض", "ارض", "اراضي", "أراضي", "اراضى", "اراض", "للبيع"],
    description:
      "أراضي سكنية و وتجارية و زراعية وصناعية للبيع بمساحات و أسعار مختلفة في جميع مدن ومناطق السعودية مع خدمة الاطلاع على المؤشرات العقارية من عقار ، تطبيق عقار",
  },
  "فلل-للبيع": {
    id: 3,
    ga_listing_type: "sale",
    ga_property_category: "villa",
    is_rent: false,
    name: "فيلا للبيع",
    en: "Villa for sale",
    plural: "فلل للبيع",
    uri: "فلل-للبيع",
    path: "/فلل-للبيع",
    keywords: ["فيلا", "دوبلكس", "دبلكس", "دوبلكسات", "فلل", "للبيع"],
    description:
      "أفضل إعلانات الفلل للبيع في جميع مدن ومناطق السعودية بالصور، تواصل مع المالك مباشرة أو المكتب و اعرف تفاصيل الحي مع خدمة تقييم الأحياء على تطبيق عقار ، تطبيق عقار",
  },
  "دور-للإيجار": {
    id: 4,
    ga_listing_type: "rent",
    ga_property_category: "flat",
    is_rent: true,
    name: "دور للإيجار",
    en: "Big flat for rent",
    plural: "دور للإيجار",
    uri: "دور-للإيجار",
    path: "/دور-للإيجار",
    keywords: ["دور", "أدوار", "للإيجار", "تأجير", "أجار"],
    description:
      "ادوار للايجار بأحياء الرياض و جدة و مكة والدمام و الخبر وجميع مدن ومناطق السعودية، يمكنك البحث عن دور ارضي أو أول أو ثاني بسعر مناسب على عقار ، تطبيق عقار",
  },
  "فلل-للإيجار": {
    id: 5,
    ga_listing_type: "rent",
    ga_property_category: "villa",
    is_rent: true,
    name: "فيلا للإيجار",
    en: "Villa for rent",
    plural: "فلل للإيجار",
    uri: "فلل-للإيجار",
    path: "/فلل-للإيجار",
    keywords: [
      "فيلا",
      // "دوبلكس",
      "دبلكس",
      "دوبلكسات",
      "فلل",
      "للإيجار",
      "تأجير",
      "أجار",
      "فلل للإيجار",
    ],
    description:
      "ابحث عن فيلا أو دبلكس للايجار في جميع أحياء مدن ومناطق السعودية بإيجار سنوي أوشهري أويومي بمساحات مختلفة بأفضل الأسعار مع تصفح الصور والتفاصي ، تطبيق عقار",
  },
  "شقق-للبيع": {
    id: 6,
    ga_listing_type: "sale",
    ga_property_category: "apartment",
    is_rent: false,
    name: "شقة للبيع",
    en: "Apartment for sale",
    plural: "شقق للبيع",
    uri: "شقق-للبيع",
    path: "/شقق-للبيع",
    keywords: ["شقة", "شقق", "للبيع"],
    description:
      "تصفح آلاف عروض الشقق للبيع في جميع مدن ومناطق السعودية بأسعار ومساحات مناسبة بالصور والتفاصيل. مع الاطلاع على ميزة تقييم الحي في تطبيق عقار ، تطبيق عقار",
  },
  "عمائر-للبيع": {
    id: 7,
    ga_listing_type: "sale",
    ga_property_category: "building",
    is_rent: false,
    name: "عمارة للبيع",
    en: "Building for sale",
    plural: "عمائر للبيع",
    uri: "عمائر-للبيع",
    path: "/عمائر-للبيع",
    keywords: ["عمائر", "عمارات", "عماير", "للبيع"],
    description:
      "عمائر سكنية وتجارية للبيع في الرياض و مكة والمدينة وجميع مدن ومناطق السعودية بمساحات و مميزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ... ، تطبيق عقار",
  },
  "محلات-للإيجار": {
    id: 8,
    ga_listing_type: "rent",
    ga_property_category: "store",
    is_rent: true,
    name: "محل للإيجار",
    en: "Store for rent",
    plural: "محلات للإيجار",
    uri: "محلات-للإيجار",
    path: "/محلات-للإيجار",
    keywords: ["محل", "محال", "محلات", "للإيجار", "تأجير", "أجار"],
    description:
      "محلات ومعارض تجارية للإيجار في الرياض و مكة والمدينة وجميع مدن ومناطق السعودية بمساحات و مميزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ...  ، تطبيق عقار",
  },
  "بيت-للبيع": {
    id: 9,
    ga_listing_type: "sale",
    ga_property_category: "house",
    is_rent: false,
    name: "بيت للبيع",
    en: "Small house for sale",
    plural: "بيت للبيع",
    uri: "بيت-للبيع",
    path: "/بيت-للبيع",
    keywords: ["بيت", "بيوت", "للبيع"],
    description:
      "بيوت من دور واحد , وبيت شعبية للبيع في جميع مدن ومناطق السعودية الرياض و مكة و جدة و الدمام والمدينة بمساحات و أسعار مختلفة مع الصور والتفاصيل ، تطبيق عقار",
  },
  "استراحة-للبيع": {
    id: 10,
    ga_listing_type: "sale",
    ga_property_category: "lounge",
    is_rent: false,
    name: "استراحة للبيع",
    en: "Lounge for sale",
    plural: "استراحة للبيع",
    uri: "استراحة-للبيع",
    path: "/استراحة-للبيع",
    keywords: [
      "استراحة",
      "استراحات",
      "منتجعات",
      "شاليهات",
      "منتزه",
      "منتزهات",
      "للبيع",
    ],
    description:
      "استراحات فاخرة للبيع في الرياض و جدة و الخبر ومكة وجميع مدن ومناطق السعودية بمساحات وأسعار مناسبة مع تصفح الصور والتفاصيل و المميزات والخدمات ... ، تطبيق عقار",
  },
  "بيت-للإيجار": {
    id: 11,
    ga_listing_type: "rent",
    ga_property_category: "house",
    is_rent: true,
    name: "بيت للإيجار",
    en: "Small house for rent",
    plural: "بيت للإيجار",
    uri: "بيت-للإيجار",
    path: "/بيت-للإيجار",
    keywords: ["بيت", "بيوت", "للإيجار", "تأجير", "أجار"],
    description:
      "للبحث عن بيوت من دور واحد أو بيوت شعبية للإيجار الشهري أو السنوي في مدن ومناطق السعودية الرياض و مكة و جدة و الدمام والمدينة بمساحات و أسعار مناسبة ، تطبيق عقار",
  },
  "مزرعة-للبيع": {
    id: 12,
    ga_listing_type: "sale",
    ga_property_category: "farm",
    is_rent: false,
    name: "مزرعة للبيع",
    en: "Farm for sale",
    plural: "مزرعة للبيع",
    uri: "مزرعة-للبيع",
    path: "/مزرعة-للبيع",
    keywords: ["مزرعة", "مزارع", "للبيع"],
    description:
      "مزارع للبيع في الرياض و جدة و الخبر ومكة وجميع مدن ومناطق السعودية بمساحات وأسعار مناسبة مع تصفح الصور والتفاصيل و المميزات والخدمات ... ، تطبيق عقار",
  },
  "استراحة-للإيجار": {
    id: 13,
    ga_listing_type: "rent",
    ga_property_category: "lounge",
    is_rent: true,
    name: "استراحة للإيجار",
    en: "Lounge for rent",
    plural: "استراحة للإيجار",
    uri: "استراحة-للإيجار",
    path: "/استراحة-للإيجار",
    keywords: [
      "استراحة",
      "استراحات",
      "منتجعات",
      "شاليهات",
      "منتزه",
      "منتزهات",
      "للإيجار",
      "تأجير",
      "أجار",
    ],
    description:
      "استراحات فاخرة للحجز اليومي والشهري والسنوي للعوائل والأفراد بمساحات وأسعار مناسبة مع تصفح الصور والتفاصيل و المميزات والخدمات و الأماكن القريبة ... ، تطبيق عقار",
  },
  "مكتب-تجاري-للإيجار": {
    id: 14,
    ga_listing_type: "rent",
    ga_property_category: "office",
    is_rent: true,
    name: "مكتب تجاري للإيجار",
    en: "Office for rent",
    plural: "مكتب تجاري للإيجار",
    uri: "مكتب-تجاري-للإيجار",
    path: "/مكتب-تجاري-للإيجار",
    keywords: ["مكتب تجاري", "مكاتب تجارية", "للإيجار", "تأجير", "أجار"],
    description:
      "مكاتب تجارية و إدارية للإيجار في الرياض و مكة والمدينة وجميع مدن ومناطق السعودية بمساحات و مميزات وتجهيزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ... ، تطبيق عقار",
  },
  "أراضي-للإيجار": {
    id: 15,
    ga_listing_type: "rent",
    ga_property_category: "land",
    is_rent: true,
    name: "أرض للإيجار",
    en: "Land for rent",
    plural: "أراضي للإيجار",
    uri: "أراضي-للإيجار",
    path: "/أراضي-للإيجار",
    keywords: [
      "أرض",
      "ارض",
      "اراضي",
      "أراضي",
      "اراضى",
      "اراض",
      "للإيجار",
      "تأجير",
      "أجار",
    ],
    description:
      "أراضي سكنية و وتجارية و زراعية وصناعية للإيجار بمساحات و أسعار مختلفة في جميع مدن ومناطق السعودية مع خدمة الاطلاع على المؤشرات العقارية من عقار ، تطبيق عقار",
  },
  "عمائر-للإيجار": {
    id: 16,
    ga_listing_type: "rent",
    ga_property_category: "building",
    is_rent: true,
    name: "عمارة للإيجار",
    en: "Building for rent",
    plural: "عمائر للإيجار",
    uri: "عمائر-للإيجار",
    path: "/عمائر-للإيجار",
    keywords: ["عمائر", "عمارات", "عماير", "للإيجار", "تأجير", "أجار"],
    description:
      "عمائر سكنية وتجارية للإيجار في الرياض و مكة والمدينة وجميع مدن ومناطق السعودية بمساحات و مميزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ...  ، تطبيق عقار",
  },
  "مستودع-للإيجار": {
    id: 17,
    ga_listing_type: "rent",
    ga_property_category: "warehouse",
    is_rent: true,
    name: "مستودع للإيجار",
    en: "Warehouse for rent",
    plural: "مستودع للإيجار",
    uri: "مستودع-للإيجار",
    path: "/مستودع-للإيجار",
    keywords: ["مستودع", "مستودعات", "للإيجار", "تأجير", "أجار"],
    description:
      "مستودعات للإيجار بإيجار سنوي وشهري ويومي في جميع مدن ومناطق السعودية بمساحات و مميزات وتجهيزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ... ، تطبيق عقار",
  },
  "مخيم-للإيجار": {
    id: 18,
    ga_listing_type: "rent",
    ga_property_category: "tent",
    is_rent: true,
    name: "مخيم للإيجار",
    en: "Tent for rent",
    plural: "مخيم للإيجار",
    uri: "مخيم-للإيجار",
    path: "/مخيم-للإيجار",
    keywords: ["مخيم", "مخيمات", "للإيجار", "تأجير", "أجار"],
    description:
      "مخيمات فاخرة للإيجار بالساعة و الحجز اليومي والشهري بمساحات وأسعار مناسبة مع تصفح الصور والتفاصيل و المميزات والخدمات و الأماكن القريبة على عقار ... ، تطبيق عقار",
  },
  "غرف-للإيجار": {
    id: 19,
    ga_listing_type: "rent",
    ga_property_category: "room",
    is_rent: true,
    name: "غرفة للإيجار",
    en: "Room for rent",
    plural: "غرف للإيجار",
    uri: "غرف-للإيجار",
    path: "/غرف-للإيجار",
    keywords: ["غرفة", "غرف", "للإيجار", "تأجير", "أجار"],
    description:
      "غرف للإيجار بإيجار يومي و شهري وسنوي بالرياض و جدة و مكة والدمام و الخبر وجميع مدن ومناطق السعودية مؤثثة وبدون تأثيث بأسعار مناسبة و مساحات مختلفة ، تطبيق عقار",
  },
  "محلات-للبيع": {
    id: 20,
    ga_listing_type: "sale",
    ga_property_category: "store",
    is_rent: false,
    name: "محل للبيع",
    en: "Store for sale",
    plural: "محلات للبيع",
    uri: "محلات-للبيع",
    path: "/محلات-للبيع",
    keywords: ["محل", "محال", "محلات", "للبيع"],
    description:
      "محلات ومعارض تجارية للبيع و التقبيل في الرياض و مكة والمدينة وجميع مدن ومناطق السعودية بمساحات و مميزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ...  ، تطبيق عقار",
  },
  "دور-للبيع": {
    id: 22,
    ga_listing_type: "sale",
    ga_property_category: "floor",
    is_rent: false,
    name: "دور للبيع",
    en: "Floor for sale",
    plural: "دور للبيع",
    uri: "دور-للبيع",
    path: "/دور-للبيع",
    keywords: [
      "دور للبيع",
      "ادوار للبيع",
      "دور ارضي للبيع",
      "بيت دور للبيع",
      "ادوار تمليك",
    ],
    description:
      "أدوار للبيع بأحياء الرياض و جدة و مكة والدمام و الخبر وجميع مدن ومناطق السعودية، يمكنك البحث عن دور أرضي أو أول أو ثاني بأسعار مناسبة على عقار ، تطبيق عقار",
  },
  "شاليه-للإيجار": {
    id: 23,
    ga_listing_type: "rent",
    ga_property_category: "chalet",
    is_rent: true,
    name: "شاليه للإيجار",
    en: "Chalet for rent",
    plural: "شاليه للإيجار",
    uri: "شاليه-للإيجار",
    path: "/شاليه-للإيجار",
    keywords: ["شاليه", "شاليهات", "شاليه للايجار", "للإيجار"],
    description:
      "تصفح أفضل وأرخص الشاليهات للحجز اليومي والشهري والسنوي في مكان واحد بمساحات وأسعار مناسبة، ابحث بالخريطة وتصفح الصور والتفاصيل و الأماكن القريبة ... ، تطبيق عقار",
  },
  أخرى: {
    id: 24,
    ga_listing_type: null,
    ga_property_category: "other",
    is_rent: false,
    name: "أخرى",
    en: "Other",
    plural: "أخرى",
    uri: "أخرى",
    path: "/أخرى",
    keywords: ["أخرى"],
  },
  "شقق-مفروشة-للحجز": {
    id: 101,
    ga_listing_type: "daily",
    ga_property_category: "apartment",
    is_rent: true,
    name: "شقة مفروشة للحجز",
    en: "Apartment for booking",
    plural: "شقق مفروشة للحجز",
    uri: "شقق-مفروشة-للحجز",
    path: "/شقق-مفروشة-للحجز",
    keywords: ["حجز", "مفروشة", "للحجز", "شقة"],
  },
  "فلل-مفروشة-للحجز": {
    id: 102,
    ga_listing_type: "daily",
    ga_property_category: "villa",
    is_rent: true,
    name: "فيلا مفروشة للحجز",
    en: "Villa for booking",
    plural: "فلل مفروشة للحجز",
    uri: "فلل-مفروشة-للحجز",
    path: "/فلل-مفروشة-للحجز",
    keywords: ["حجز", "مفروشة", "للحجز", "فيلا"],
  },
  "استديوهات-مفروشة-للحجز": {
    id: 103,
    ga_listing_type: "daily",
    ga_property_category: "studio",
    is_rent: true,
    name: "استديو مفروش للحجز",
    en: "Studio for booking",
    plural: "استديوهات مفروشة للحجز",
    uri: "استديوهات-مفروشة-للحجز",
    path: "/استديوهات-مفروشة-للحجز",
    keywords: ["حجز", "مفروش", "استديو", "للحجز"],
  },
  "شاليهات-للحجز": {
    id: 104,
    ga_listing_type: "daily",
    ga_property_category: "chalet",
    is_rent: true,
    name: "شاليه للحجز",
    en: "Chalet for booking",
    plural: "شاليهات واستراحات للحجز",
    uri: "شاليهات-للحجز",
    path: "/شاليهات-للحجز",
    keywords: ["حجز", "للإيجار", "للحجز", "شاليه"],
  },

  /*
  *   "استراحات-للحجز": {
    id: 105,
    ga_listing_type: "daily",
    ga_property_category: "lounge",
    is_rent: true,
    name: "استراحة للحجز",
    en: "Lounge for booking",
    plural: "استراحات للحجز",
    uri: "استراحات-للحجز",
    path: "/استراحات-للحجز",
    keywords: ["حجز", "للإيجار", "استراحة", "للحجز"],
  },
  * */
  "مخيمات-للحجز": {
    id: 106,
    ga_listing_type: "daily",
    ga_property_category: "tent",
    is_rent: true,
    name: "مخيم للحجز",
    en: "Tent for booking",
    plural: "مخيمات للحجز",
    uri: "مخيمات-للحجز",
    path: "/مخيمات-للحجز",
    keywords: ["حجز", "للإيجار", "مخيم", "للحجز"],
  },
  "مزارع-للحجز": {
    id: 107,
    ga_listing_type: "daily",
    ga_property_category: "farm",
    is_rent: true,
    name: "مزرعة للحجز",
    en: "Farm for booking",
    plural: "مزارع للحجز",
    uri: "مزارع-للحجز",
    path: "/مزارع-للحجز",
    keywords: ["حجز", "للإيجار", "مزرعة", "للحجز"],
  },
  "قاعات-للحجز": {
    id: 108,
    ga_listing_type: "daily",
    ga_property_category: "hall",
    is_rent: true,
    name: "قاعة للحجز",
    en: "Hall for booking",
    plural: "قاعات للحجز",
    uri: "قاعات-للحجز",
    path: "/قاعات-للحجز",
    keywords: ["حجز", "للإيجار", "للحجز", "قاعة"],
  },
};
export const description = {
  "شقق-للإيجار":
    "شقق للايجار ب%place بالصور و الأسعار, يمكنكم البحث عن شقق ب%place بسعر مناسب",
  "أراضي-للبيع":
    "اراضي للبيع ب%place بسعر المتر و الصور, يمكنك البحث عن ارض للبيع ب%place بسعر مناسب من المالك", // اراصى للبيع
  "فلل-للبيع":
    "فلل للبيع ب%place و قصور للبيع ب%place. يمكنك البحث عن فلل ب%place بسعر مناسب", // فلل للبيع
  "دور-للإيجار":
    "ادوار للايجار ب%place بجميع الأحياء و الأسعار. يمكنك البحث عن دور ارضي ب%place بسعر مناسب", // دور للايجار
  "فلل-للإيجار":
    " فلل للايجار ب%place يمكنك ايجاد فيلا أو دبلكس للايجار ب%place بسعر مناسب", // فلل للايجار
  "شقق-للبيع":
    "شقق للبيع ب%place بالصور و شقق تمليك. يمكنك ايجاد شقق للبيع ب%place بسعر مناسب", // شقق للبيع
  "عمائر-للإيجار":
    "عمائر سكنية وتجارية للإيجار في %place بمساحات و مميزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ... ",
  عقارات:
    "تصفح آلاف العقارات المعروضة للبيع والايجار في %place بمساحات وأسعار مختلفة مع الاطلاع على أفضل الأحياء تقييمًا من خلال ميزة تقييم الحي في تطبيق عقار",
  "عمائر-للبيع":
    "عمائر سكنية وتجارية للبيع في %place بمساحات و مميزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ...",
  "محلات-للإيجار":
    "محلات ومعارض تجارية للإيجار في %place بمساحات و مميزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ... ",
  "بيت-للبيع":
    "بيوت من دور واحد , وبيوت شعبية للبيع في  %place بمساحات و أسعار مختلفة مع الصور والتفاصيل",
  "استراحة-للبيع":
    "استراحات فاخرة للبيع في %place بمساحات وأسعار مناسبة مع تصفح الصور والتفاصيل و المميزات والخدمات ...",
  "بيت-للإيجار":
    "للبحث عن بيوت من دور واحد أو بيوت شعبية للإيجار الشهري أو السنوي في %place بمساحات و أسعار مناسبة",
  "مزرعة-للبيع":
    "مزارع للبيع %place بمساحات وأسعار مناسبة مع تصفح الصور والتفاصيل و المميزات والخدمات ...",
  "استراحة-للإيجار":
    "استراحات فاخرة للحجز اليومي والشهري والسنوي للعوائل والأفراد في %place بمساحات وأسعار مناسبة مع تصفح الصور والتفاصيل و المميزات والخدمات و الأماكن القريبة ...",
  "مكتب-تجاري-للإيجار":
    "مكاتب تجارية و إدارية للإيجار في %place بمساحات و مميزات وتجهيزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ...",
  "أراضي-للإيجار":
    "أراضي سكنية و وتجارية و زراعية وصناعية للإيجار بمساحات و أسعار مختلفة في %place مع خدمة الاطلاع على المؤشرات العقارية من عقار",
  "مستودع-للإيجار":
    "مستودعات للإيجار بإيجار سنوي وشهري ويومي في %place بمساحات و مميزات وتجهيزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ...",
  "مخيم-للإيجار":
    "مخيمات فاخرة للإيجار بالساعة و الحجز اليومي والشهري في %place بمساحات وأسعار مناسبة مع تصفح الصور والتفاصيل و المميزات والخدمات و الأماكن القريبة على عقار ...",
  "غرف-للإيجار":
    "غرف للإيجار بإيجار يومي و شهري وسنوي ب%place مؤثثة وبدون تأثيث بأسعار مناسبة و مساحات مختلفة",
  "محلات-للبيع":
    "محلات ومعارض تجارية للبيع و التقبيل في %place بمساحات و مميزات مختلفة بأفضل الأسعار مع الصور والتفاصيل ... ",
  "شقة-مفروشة":
    "شقق مفروشة للعائلات و الأفراد بإيجار يومي و شهري وسنوي في %place بأسعار مناسبة بالصور والتفاصيل مع امكانية البحث على خريطة عقار",
  "دور-للبيع":
    "أدوار للبيع %place، يمكنك البحث عن دور أرضي أو أول أو ثاني بأسعار مناسبة على عقار",
  "شاليه-للإيجار":
    "تصفح أفضل وأرخص الشاليهات للحجز اليومي والشهري والسنوي في %place بمساحات وأسعار مناسبة، ابحث بالخريطة وتصفح الصور والتفاصيل و الأماكن القريبة ...",
};

export default categories;
